import { useMemo } from 'react';
import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import { getAllBoostPoolIdsQuery } from '@/shared/graphql/lp/boost';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { type BoostPoolId } from '@/shared/utils/boost';

export type BoostPoolIdMap = Record<BoostPoolId, number>;

export default function useBoostPoolId(params?: {
  asset?: ChainflipAsset;
  feeBps?: number;
  activeOnly?: boolean;
}) {
  const { asset, feeBps, activeOnly = false } = params ?? {};

  const { data } = useGqlQuery(getAllBoostPoolIdsQuery, {
    context: { clientName: 'lpProcessor' },
  });

  const boostPoolIds = useMemo(() => {
    if (!data?.pools?.nodes) return undefined;

    return Object.fromEntries(
      data?.pools?.nodes
        .filter((pool) => (!asset || pool.asset === asset) && (!activeOnly || pool.isActive))
        .map((pool) => [`${pool.asset}-${pool.feeTierPips}`, pool.id]),
    ) as BoostPoolIdMap;
  }, [data, activeOnly]);

  return {
    boostPoolIds,
    boostPoolId:
      asset === undefined || feeBps === undefined
        ? undefined
        : boostPoolIds?.[`${asset}-${feeBps}`],
  };
}
